import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  Tooltip,
  Box
} from '@mui/material';
import {
  LightMode,
  DarkMode,
  SettingsBrightness
} from '@mui/icons-material';

const ThemeToggler = () => {
  const { mode, toggleTheme } = useContext(ThemeContext);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getCurrentIcon = () => {
    switch (mode) {
      case 'light': return <LightMode fontSize='small' />;
      case 'dark': return <DarkMode fontSize='small' />;
      default: return <SettingsBrightness fontSize='small' />;
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title='Theme settings'>
        <IconButton
          onClick={handleClick}
          color='inherit'
          aria-label='theme toggle'
          sx={{
            p: 0.5,
            '&:hover': {
              backgroundColor: theme.palette.action.hover
            }
          }}
        >
          {getCurrentIcon()}
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        disableScrollLock // Prevent body scroll
        PaperProps={{
          sx: {
            minWidth: 120,
            maxWidth: 160,
            bgcolor: theme.palette.background.paper,
            boxShadow: theme.shadows[3],
            transition: 'transform 0.2s ease, opacity 0.2s ease',
            '& .MuiListItemText-primary': {
              fontSize: { xs: '0.875rem', sm: '0.9rem', md: '1rem' },
              fontWeight: 500
            }
          }
        }}
      >
        <MenuItem
          onClick={() => { toggleTheme('system'); handleClose(); }}
          dense
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <SettingsBrightness fontSize='small' />
          </ListItemIcon>
          <ListItemText>System</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => { toggleTheme('light'); handleClose(); }}
          dense
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <LightMode fontSize='small' />
          </ListItemIcon>
          <ListItemText>Light</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => { toggleTheme('dark'); handleClose(); }}
          dense
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <DarkMode fontSize='small' />
          </ListItemIcon>
          <ListItemText>Dark</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ThemeToggler;
